import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable} from 'rxjs';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { PasswordValidator, passwordMatchValidator } from '../../shared/custom-validators';
import { SharedService } from '../../shared/shared.service';
import { HttpService } from '../../services/main_local.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-set-password',
  templateUrl: './setPassword.component.html',
  styleUrls: ['./setPassword.component.scss']
})
export class SetPasswordComponent implements OnInit {
  setPasswordForm!: FormGroup;
  id:any;
  authToken: any = null; 
  isHandset$: Observable<boolean> = this.sharedService.isHandset()

  constructor(    
    private fb: FormBuilder,
    private router : Router,
    private route : ActivatedRoute,
    private spinner: NgxSpinnerService,
    private snackBar:MatSnackBar,
    private httpService : HttpService,
    private sharedService : SharedService) { }
    hide = true;
    confirmhide = true;
    flag:any;
    mobileNumber:any;
    countryCode:any = '+678'
    ngOnInit(): void {
    this.setPasswordForm= this.fb.group(
      {
      password: ['', [Validators.required, PasswordValidator]],
      confirmPassword: ['', [Validators.required,PasswordValidator, passwordMatchValidator('password')]],
     },
    );

    this.route.queryParams.subscribe((params) => {
      this.id = +params['id'];
      this.flag = params['flag'];
      this.mobileNumber = params['mob'];
    });
  }
  ngAfterViewInit(): void {
    console.log("afterViweInit");
  }

  keyPressPassword(event:any){
    let inp = String.fromCharCode(event.keyCode);
  
    if (/[><,:;^'"]/.test(inp)) {
      event.preventDefault();
      return false;
    } else {
      
      return true;
    }
  }

  cancel(){
      this.router.navigate(['/login'])
  }

  onSave(){
    this.spinner.show();
    const body: any = {
      "isdCode": this.countryCode,
      "mobileNumber": this.mobileNumber,
      "newPassword": this.setPasswordForm.get('password')?.value
    }
    this.httpService.postRequestCall('auth/setPassword', body, this.authToken, {}).subscribe({
      next: (value)=>{
        let val:any = value;
        this.spinner.hide();
        this.snackBar.open((val?.message), '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        this.router.navigate(['/login'])
      },
      error:(err)=>{
        this.errorStatusFun(err);
      }
    })
  }
  errorStatusFun(error:any){
    this.spinner.hide();
    this.snackBar.open((error.error.message), '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }
}
